module.exports = __webpack_public_path__ + "img/en.497e7cd1.svg";